import type { InjectionKey } from 'vue'
import type { FormServiceType } from '../services/form.service'
import type { Ref } from 'vue'

export const FormServiceKey: InjectionKey<FormServiceType | Ref<FormServiceType>> = Symbol('FormService') as InjectionKey<FormServiceType | Ref<FormServiceType>>
